import React, { useState, useMemo, useCallback } from 'react';

import { subDays, format } from 'date-fns';
import { isNull, isEmpty } from 'lodash';

import { Report } from '~/components';
import {
  DateTime,
  Autocomplete,
  Input,
  MultiAutocomplete,
  RadioGroup,
} from '~/components/Form';
import { PesquisaTabela } from '~/components/Form/v2';
import { t } from '~/helpers';

export default function RelAlinhamentoTanque() {
  const [open, setOpen] = useState(true);
  const [posto, setPosto] = useState(null);
  const [nomeposto, setNomeposto] = useState('');
  const [virtual, setVirtual] = useState({ label: '', value: '' });

  const [valuePosto, setValuePosto] = React.useState([]);
  const [valueProduto, setValueProduto] = React.useState(0);

  const dateTime = useMemo(
    () => ({
      start: format(subDays(new Date(), 7), 'dd/MM/yyyy 00:00:00'),
      end: format(new Date(), 'dd/MM/yyyy 23:59:59'),
    }),
    []
  );

  const options = useMemo(
    () => [
      { label: 'PDF', value: 'pdf' },
      { label: 'Excel', value: 'excel' },
    ],
    []
  );

  const cells = useMemo(
    () => [
      {
        id: 'codigousuario',
        label: t('s.cadastro.usuario.codigousuario'),
        filter: { type: 'text' },
      },
      {
        id: 'nomeusuario',
        label: t('s.cadastro.usuario.nomeusuario'),
        filter: { type: 'text' },
      },
    ],
    []
  );

  const handleSetDataTank = useCallback((data) => {
    setPosto(data || null);
    setNomeposto(data || '');
    setVirtual({ label: '', value: '' });
  }, []);

  /* const handleSerializeFormData = useCallback(
    (data) => ({
      ...data,
      nomeposto,
      idtanquevirtual: virtual.value ?? '',
    }),
    [nomeposto, virtual]
  ); */

  function handleSerializeForm(params) {
    const idPosto = posto === 0 ? '' : posto?.map((posto) => posto.idposto);
    return {
      ...params,
      idposto: idPosto,
      idtanquevirtual: virtual.value ?? '',
    };
  }

  const handleSetVirtualTank = useCallback((data) => {
    setVirtual({
      label: data,
      value: data.split(':').shift(),
    });
  }, []);

  return (
    <Report
      open={open}
      onClose={() => setOpen(false)}
      title={t('s.menu.relatorio.relalinhamentotanque')}
      relatorio="relalinhamentotanque"
      serialize={(param) => handleSerializeForm(param)}
      initials={{
        datahorainicial: dateTime.start,
        datahorafinal: dateTime.end,
        formato: 'pdf',
      }}
    >
      <DateTime
        time
        name="datahorainicial"
        label={t('s.geral.opcoes.datahorainicial')}
      />

      <DateTime
        time
        name="datahorafinal"
        label={t('s.geral.opcoes.datahorafinal')}
      />

      <MultiAutocomplete
        multiple
        name="idposto"
        label="codigonomeposto"
        url="postoscomboios"
        unique="idposto"
        title={t('s.geral.postocomboio')}
        hiddens={[{ name: 'codigonomeposto' }]}
        getValue={handleSetDataTank}
      />

      {/*   <Autocomplete
        name="idposto"
        label="codigonomeposto"
        url="postos"
        unique="idposto"
        title={t('s.geral.postocomboio')}
        getValue={handleSetDataTank}
    /> */}

      <Autocomplete
        disabled={isNull(posto) || posto.length > 1}
        disableClearable={isEmpty(virtual.label)}
        name="idtanquevirtual"
        label="tanquevirtualprodutotanquevirtual"
        url="tanquesvirtuais"
        unique="idtanquevirtual"
        title={t('s.configuracao.bico.idtanquevirtual')}
        inputValue={virtual.label}
        onInputChange={(_, value) => handleSetVirtualTank(value)}
        params={{
          wherefield: ['idposto'],
          valuewherefield: [
            posto && posto.length == 1 ? posto[0]?.idposto : '',
          ],
          typewherefield: ['EQUALS'],
        }}
      />

      <Input
        name="codigotanquefisico"
        label={t('s.configuracao.tanquefisico.codigotanquefisico')}
      />

      <PesquisaTabela
        name="codigousuario"
        label={t('s.operacao.recebimento.codigousuario')}
        primary="codigousuario"
        secondary="nomeusuario"
        url="usuarios"
        header={cells}
      />

      <RadioGroup
        row
        name="formato"
        label={t('s.relatorio.geral.formato')}
        options={options}
        serialize={(value) => value}
      />
    </Report>
  );
}
